import React, {useEffect, StyleHTMLAttributes} from 'react'
import { IconCtaItem } from '../Data/IconCtaItem'

interface IconButtonProps {
    cta: IconCtaItem | undefined
    id: string | null
}

export default ({ cta, id }: IconButtonProps) => {
    const styles = {
        '--cta-bg-image': (`url('${cta?.getImageUrl()}')`),
        "--cta-bg-hover-image": (`url('${cta?.getImageHoverUrl()}')`),
    }
    return <a className="btn btn-animal" href={`${window.tnewUrl}/donate/i/${id}`}><span className='btn-cta-image' style={styles as any}></span>{ cta?.ctaText }</a>
}